.sub-item:hover {
    background-color: transparent;
    transform: translateX(4px);
    box-shadow: none;
}

.sub-item .v-list-item__content,
.sub-item .v-list-item__action {
    position: relative;
    z-index: 2;
}

.sub-item.v-list-item--active .v-list-item__content,
.sub-item.v-list-item--active .v-list-item__action {
    background-color: transparent !important;
}

.sub-item-line {
    position: absolute;
    left: 16px;
    top: 6px;
    bottom: 6px;
    <template>
        <div>
            <!-- Item principal do grupo -->
            <v-list-item
                @click="toggle"
                active-class="white--text"
                class="item-menu"
                style="cursor: pointer"
            >
                <v-list-item-action>
                    <v-icon class="item-menu">{{ icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title class="item-menu">{{ title }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                    <v-icon class="item-menu">
                        {{ isOpen ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                    </v-icon>
                </v-list-item-action>
            </v-list-item>

            <!-- Subitens -->
            <v-expand-transition>
                <div v-show="isOpen" class="sub-list">
                    <v-list-item
                        v-for="(subItem, index) in subItems"
                        :key="index"
                        :to="{ name: subItem.routeName }"
                        :active-class="'white--text no-active-bg'"
                        class="item-menu sub-item"
                        style="padding-left: 56px"
                    >
                        <v-list-item-action style="min-width: 32px">
                            <v-icon class="item-menu" size="20">{{ subItem.icon }}</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title class="item-menu">{{ subItem.title }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </div>
            </v-expand-transition>
        </div>
    </template>

    <script>
    export default {
        name: 'MenuGroup',
        props: {
            icon: String,
            title: String,
            subItems: Array,
            defaultOpen: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                isOpen: this.defaultOpen
            };
        },
        created() {
            if (this.hasActiveChild()) {
                this.isOpen = true;
            }
        },
        watch: {
            '$route'() {
                if (this.hasActiveChild()) {
                    this.isOpen = true;
                }
            }
        },
        methods: {
            toggle() {
                this.isOpen = !this.isOpen;
            },
            hasActiveChild() {
                if (!this.subItems) return false;
                return this.subItems.some(subItem => subItem.routeName === this.$route.name);
            }
        }
    };
    </script>

    <style scoped>
    .item-menu {
        color: white;
        font-size: 13px;
    }

    .sub-item {
        background-color: transparent;
        transition: all 0.2s ease;
        border-radius: 0;
        margin: 1px 6px;
        padding-left: 24px;
        position: relative;
        z-index: 0;
    }

    .sub-item.v-list-item--active {
        background-color: transparent !important;
        box-shadow: none !important;
    }

    .no-active-bg {
        background-color: transparent !important;
        box-shadow: none !important;
    }

    .sub-item.v-list-item--active::after,
    .sub-item:hover::after,
    .sub-item::after {
        content: none !important;
    }

    .sub-item::before,
    .sub-item.v-list-item--active::before,
    .sub-item:hover::before {
        display: none !important;
    }

    .sub-item:hover {
        background-color: transparent;
        transform: translateX(4px);
        box-shadow: none;
    }

    .sub-item .v-list-item__content,
    .sub-item .v-list-item__action {
        position: relative;
        z-index: 2;
    }

    .sub-item.v-list-item--active .v-list-item__content,
    .sub-item.v-list-item--active .v-list-item__action {
        background-color: transparent !important;
    }

    .sub-list {
        position: relative;
    }

    .sub-list::before {
        content: '';
        position: absolute;
        left: 32px;
        top: 8px;
        bottom: 8px;
        border-left: 2px dotted rgba(255, 255, 255, 0.9);
        pointer-events: none;
        z-index: 0;
    }

    .v-list-item__content {
        text-align: left !important;
        align-items: flex-start !important;
        margin-left: 4px !important;
        transition: all 0.3s ease;
    }

    .v-list-item {
        justify-content: flex-start !important;
        transition: all 0.2s ease;
        border-radius: 0;
        margin: 1px 6px;
        background: transparent !important;
    }

    .v-list-item:hover {
        transform: none;
        box-shadow: none;
        background-color: transparent !important;
    }

    .v-list-item:hover .v-list-item__content {
        transform: translateX(3px);
    }

    .v-list-item:hover .v-list-item__action {
        transform: translateX(2px);
    }

    .v-list-item__action {
        margin-right: 6px !important;
        transition: all 0.3s ease;
    }

    .v-icon.item-menu {
        font-size: 18px !important;
    }
    </style>

